import React from "react";
import { useTranslation } from "react-i18next"; // I18N
import SectionTitle from "../SectionTitle/SectionTitle";

// I18N — icon classes paired with translation keys
const featuresData = [
  { iconClass: "fa-users", key: "communityLed" },
  { iconClass: "fa-hand-holding-heart", key: "transparent" },
  { iconClass: "fa-hands-helping", key: "partnerships" },
];

const FeatureSection = () => {
  const { t } = useTranslation(); // I18N
  return (
    <section className="wpo-features-area">
      <div className="container">
        <div className="features-wrap">
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-12 col-12">
              <SectionTitle
                subtitle=""
                title={t("home.features.sectionTitle")}
              />
            </div>
          </div>
          <div className="row">
            {featuresData.map((feature, index) => (
              <div className="col col-lg-4 col-md-6 col-12" key={index}>
                <div className="feature-item-wrap">
                  <div className="feature-item">
                    <div className="feature-text">
                      <div className="feature-icon">
                        <div className="icon">
                          <i className={`fi fa-solid ${feature.iconClass}`}></i>
                        </div>
                      </div>
                      <h2>{t(`home.features.${feature.key}.title`)}</h2>
                      <p>{t(`home.features.${feature.key}.description`)}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;
